import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/authContext";
import { logoutUser } from "../../utils/authUserService";
import { toast } from "react-toastify";
import "../../styles/authJourney.css";

export default function JourneyNavigation() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return <header className="journey-navigation">
    <Link to="/" aria-label="ZediPass home"><img src="/media/onboarding-journey/business-logo.svg" alt="ZediPass Business" width="194" height="26" /></Link>
    {user && <button type="button" onClick={async () => {
      try { await logoutUser(); navigate("/login", { replace: true }); }
      catch { toast.error("We could not log you out. Please try again."); }
    }}>Log out</button>}
  </header>;
}
